import { render } from "./ImageIcons.vue?vue&type=template&id=c7c9f59c"
import script from "./ImageIcons.vue?vue&type=script&lang=js"
export * from "./ImageIcons.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__